/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createClone } from '../../factoriesAny.js';
export var cloneDependencies = {
  typedDependencies,
  createClone
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesClone.generated.js
// module id = null
// module chunks = 